import React, {useRef} from 'react';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react';

import ActivityIndicator from '../../components/ui-controls/ActivityIndicator';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {StoreType} from '../../navigation/routes/types';
import {usePromotions} from '../../queries/promotions';
import {useStores} from '../../stores/use-stores';
import {navigateToGiftCardsShop} from '../../utils/giftCards';
import {getStoreType} from '../../utils/store';

// Shop → Gift cards lands here when the gift-card promotion is not loaded yet.
// Continue straight to the form. Do not render the extra BUY A GIFT CARD button,
// and do not detour through the promotion page.
export const GiftCardsPromotionWaiter = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_PROMOTION_WAITER>) => {
    const rootStore = useStores();
    const {shopSelectionStore} = rootStore;
    const {hasFetchedPromotions} = usePromotions();
    const continuedRef = useRef(false);

    useFocusEffect(() => {
      // Stay on the spinner until the promotions query has settled. An empty
      // result is settled — continue to the form, do not spin forever.
      if (!hasFetchedPromotions || continuedRef.current) return;
      continuedRef.current = true;
      const storeType = getStoreType(shopSelectionStore.selectedStore);
      if (storeType === StoreType.GiftCardStore) navigation.navigate(AppRoute.GIFT_CARDS_MAIN);
      else navigateToGiftCardsShop(rootStore);
    });

    return <ActivityIndicator />;
  },
);

export default GiftCardsPromotionWaiter;
